export default __webpack_public_path__ + "static/media/bkg--home-3.2327f462.jpg";